import { ParcialUser } from "./model";

// This function will cause compilation to fail if it is given a valid value.
// This can be used to check if switch cases are exhaustive.
export function assertUnreachable(x: never): never {
	throw new Error("Didn't expect to get here");
}

export function fullName(user: ParcialUser): string {
	let name = user.given_name;
	if (user.middle_names.length > 0) {
		name += ` ${user.middle_names}`;
	}
	name += ` ${user.family_name}`;

	return name;
}
